<!-- <div class="progress-card">
  <h2>Tu progreso</h2>
  <div class="progress-stages figma-style">
    <div class="progress-sections">
      <div class="section-item onboarding">
        <div class="section-title">Onboarding</div>
      </div>
      <div class="section-item descubrete">
        <div class="section-title">Descúbrete</div>
      </div>
      <div class="section-item planificacion">
        <div class="section-title">Planificación</div>
      </div>
      <div class="section-item acompanamiento">
        <div class="section-title">Acompañamiento</div>
      </div>
      <div class="section-item desarrollo">
        <div class="section-title">Desarrollo</div>
      </div>
    </div>

    <div class="progress-bars">
      <div class="progress-bar-wrapper onboarding">
        <div class="progress-bar" [class.completed]="true"></div>
      </div>
      <div class="progress-bar-wrapper descubrete">
        <div class="progress-bar in-progress" [style.width.%]="autoconocimientoProgress"></div>
      </div>
      <div class="progress-bar-wrapper planificacion">
        <div class="progress-bar in-progress" [style.width.%]="objetivosProgress()"></div>
      </div>
      <div class="progress-bar-wrapper acompanamiento">
        <div class="progress-bar"></div>
      </div>
      <div class="progress-bar-wrapper desarrollo">
        <div class="progress-bar"></div>
      </div>
    </div>

    <div class="grouped-subsections">
      <div class="progress-column onboarding">
        <div class="subsection-item"><span>Mapa de vida</span></div>
      </div>
      <div class="progress-column descubrete">
        <div class="subsection-item">
          <span class="active">Círculo de vida</span>
          <span [ngClass]="{ 'disabled-item': isUserFreemium }">Visionboard</span>
          <span [ngClass]="{ 'disabled-item': isUserFreemium }">PRD</span>
        </div>
      </div>
      <div class="progress-column planificacion">
        <div class="subsection-item" [ngClass]="{ 'disabled-item': isUserFreemium }">
          <span>Objetivos</span>
        </div>
      </div>
      <div class="progress-column acompanamiento">
        <div class="subsection-item" [ngClass]="{ 'disabled-item': isUserFreemium }">
          <span>Seguimiento/Avance</span>
        </div>
      </div>
      <div class="progress-column desarrollo">
        <div class="subsection-item">
          <span [ngClass]="{ 'disabled-item': isUserFreemium }">Reinvención</span>
          <span [ngClass]="{ 'disabled-item': isUserFreemium }">Ikigai</span>
          <span [ngClass]="{ 'disabled-item': isUserFreemium }">Academy</span>
          <span [ngClass]="{ 'disabled-item': isUserFreemium }">Financiera</span>
        </div>
      </div>
    </div>
  </div>
</div> -->

@if (showObjectivesAndActivities) {
<!-- Sección de Objetivos y Actividades (en 2 columnas) -->
<div class="objetivos-actividades-container">
  <!-- Sección de Objetivos -->
  <div class="objetivos-card">
    <div class="card-header">
      <h2>Objetivos</h2>
      <div class="header-right" *ngIf="isDisabledCreateObjectiveButton">
        <!-- Filtro de estado -->
        <!-- <div class="filter-container">
          <label for="filtro-estado">Filtrar por:</label>
          <select id="filtro-estado" [(ngModel)]="estadoSeleccionado" (ngModelChange)="onFiltroChange($event)">
            <option *ngFor="let estado of estadosFiltro" [value]="estado">
              {{ estado }}
            </option>
          </select>
        </div> -->

        <div class="buttons-container">
          <button class="view-button" (click)="onVerTodosObjetivos()">
            Ver objetivos
          </button>
          <button class="add-button" (click)="onCrearObjetivo()" 
           [title]="isUserFreemium ? 'Click para crear objetivos' : ''">
            Agregar objetivo +
          </button>
        </div>
      </div>
    </div>

    <div class="table-container">
      <table class="objetivos-table">
        <thead>
          <tr>
            <th>Nombre de objetivo</th>
            <th>Dimensión</th>
            <th>Fin</th>
            <th>Porcentaje</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let objetivo of objetivosFiltradosDisplay()">
            <td>
              <div class="objetivo-nombre">
                <span class="arrow-icon"></span>
                {{ objetivo.nombre }}
              </div>
            </td>
            <td>
              <span class="dimension-badge">{{ objetivo.dimension }}</span>
            </td>
            <td>{{ objetivo.fin }}</td>
            <td>
              <div class="progress-pill" [style.background-color]="
                  objetivo.porcentaje > 0 ? '#DC0A2D' : '#ccc'
                ">
                {{ objetivo.porcentaje }}%
              </div>
            </td>
          </tr>
          <!-- Mensaje cuando no hay objetivos -->
          <tr *ngIf="
              !objetivosFiltradosDisplay() ||
              objetivosFiltradosDisplay().length === 0
            ">
            <td colspan="4" class="no-data" style="text-align: center; padding: 20px">
              No hay objetivos disponibles. Crea tu primer objetivo para
              comenzar.
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <div class="ver-todo" *ngIf="objetivosFiltradosDisplay().length > 0">
        <a (click)="onVerTodosObjetivos()" style="cursor: pointer"
          >Ver todos ></a
        >
      </div> -->
    </div>
  </div>

  <!-- Sección de Actividad Reciente (al costado de Objetivos) -->
  <!-- <div class="actividad-card">
    <div class="card-header">
      <h2>Actividad</h2>
    </div>

    <div class="actividades-container">
      <div class="actividad-row" *ngFor="let actividad of actividades.slice(0, 8)">
        <div class="actividad-info">{{ actividad.nombre }}</div>
        <div class="actividad-progreso">
          <div class="progress-bar-small" [style.width.%]="actividad.progreso"></div>
        </div>
      </div>
      <div *ngIf="!actividades || actividades.length === 0" class="no-data" style="text-align: center; padding: 20px">
        No hay actividades disponibles. Las actividades aparecerán cuando crees
        objetivos con tareas.
      </div>
    </div>
  </div> -->
</div>
}